import React from 'react';

function About(){
    return (
        <p>About page</p> 
        // <h1>You creepy try'na find out who I am!</h1>
    );
}

export default About;